import contentChangeActionFactory from '../actions/factories/contentChangeActionFactory';
import formActionCreators from '../actions/formActionCreators';
import store from '../reducers/storeRegistration';
const contentChangeActions = contentChangeActionFactory('cabinet', 'forms');

/**
 *  Kick off a bulk export via a server native behavior and update the UI
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  try {
    const formStore = store.getState().form;
    const {
      pendingChanges
    } = formStore;
    // make sure the form is saved. Tried to get auto-save to work, but there's a race condition
    // with the export request -- await store.dispatch doesn't await the serverSave call
    if (pendingChanges) {
      await sourceEvaluator({
        type: 'validationErrorBehavior',
        errors: ['Please save your changes before requesting an export.']
      });
      return false;
    }

    // start the export via server behavior
    const response = await sourceEvaluator({
      type: 'bulkExportBehavior'
    });
    if (response !== null && response !== void 0 && response.success) {
      // pop an alert and reload the record
      const fullMessage = `${response.message}\nWhen the export is complete the record will have a "Complete" status and the export will be available for download.`;
      sourceEvaluator({
        type: 'alertBehavior',
        title: 'Bulk Export',
        message: fullMessage,
        options: [{
          title: 'OK',
          actions: []
        }]
      });

      // invalidate the index view so it reloads the record
      await store.dispatch(contentChangeActions.saveSuccess(content.id, content));

      // reload the form to pick up changes
      const serverShowResult = await store.dispatch(formActionCreators.serverShow(content.id));
      return serverShowResult;
    }
  } catch (e) {
    try {
      await sourceEvaluator({
        type: 'validationErrorBehavior',
        errors: [e.message || e.debugMessage || 'An error occurred while requesting the export.']
      });
    } catch (e2) {
      // if the failure is in usage of sourceEvaluator just report it on the console
      // eslint-disable-next-line no-console
      console.error('bulk export failed', e2);
    }
  }
  return false;
};
export default {
  evaluate
};